import { useState, useCallback, useEffect } from 'react';
import { reportsService } from '../services/domain/reportService';
import { userService } from '../services/domain/userService';

interface UseLeadsResult {
  dataTotal: totalValues | null;
  dataLeads: DataByProcess[];
  dataSource: DataBySource[];
  dataActivity: DataByActivity[];
  dataProgram: DataByProgram[];
  dataStatus: DataByStatus[];
  dataUsers: DataUsers[];
  loading: boolean;
  error: string | null;
  fetchData: () => Promise<void>;
  refetch: () => Promise<void>;
}

interface ReportParams {
  user_id?: string;
  start_date?: string;
  end_date?: string;
  autoFetch?: boolean; // Para cargar automáticamente al montar
}

interface totalValues {
  contactados: number,
  conversion_rate: number,
  filtered_by: string,
  inscritos: number,
  total_leads: number
}

interface Statuses {
  status_id: string,
  status_name: string,
  status_description: string,
  status_color: string,
  status_order: number,
  deal_count: number,
  percentage_of_total: number,
  percentage_of_process: number
}

interface DataByProcess {
  process_id: string,
  process_name: string,
  process_description: string,
  process_color: string,
  process_order: number,
  total_deals_in_process: number,
  percentage_of_total: number,
  statuses: Statuses[]
}

interface DataBySource {
  source_id: string,
  source_name: string,
  source_description: string,
  deal_count: number,
  percentage_of_total: number
}

interface TypeActivity {
  type_id: string,
  type_name: string,
  count: number
}

interface DataByActivity {
  user_id: string,
  user_name: string,
  total_activities: number,
  activities_by_type: TypeActivity[]
}

interface DataByProgram {
  programa_de_interes: string,
  deal_count: string
}

interface DataByStatus {
  status_id: string,
  status_name: string,
  count: number,
  percentage: string
}

interface DataUsers {
  id: number,
  email: string,
  full_name: string,
  username: string,
  created_at: string,
}



export const useReportsDeals = (params: ReportParams): UseLeadsResult => {
  const [dataTotal, setDataTotal] = useState<totalValues | null>(null);
  const [dataLeads, setDataLeads] = useState<DataByProcess[]>([]);
  const [dataSource, setDataSource] = useState<DataBySource[]>([]);
  const [dataActivity, setDataActivity] = useState<DataByActivity[]>([]);
  const [dataProgram, setDataProgram] = useState<DataByProgram[]>([]);
  const [dataStatus, setDataStatus] = useState<DataByStatus[]>([]);
  const [dataUsers, setDataUsers] = useState<DataUsers[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    

    try {

      const status_response = await reportsService.getReportsStatusDeals({
        user_id: params.user_id,
        start_date: params.start_date,
        end_date: params.end_date,
      });

      // const response = await reportsService.getConversionDeals({
      //   user_id: params.user_id,
      //   start_date: params.start_date,
      //   end_date: params.end_date,
      // });



      const source_response = await reportsService.getDealsBySource({
        user_id: params.user_id,
        start_date: params.start_date,
        end_date: params.end_date,
      });

      const response3 = await reportsService.getReportsDeals({
        user_id: params.user_id,
        start_date: params.start_date,
        end_date: params.end_date,
      });

      const response4 = await reportsService.getReportsActivities({
        user_id: params.user_id,
        start_date: params.start_date,
        end_date: params.end_date,
      });

      // const program_response = await reportsService.getReportsPrograms({
      //   user_id: params.user_id,
      //   start_date: params.start_date,
      //   end_date: params.end_date,
      // });

      

      
      const users_list = await userService.getListUsers();

      // setDataUsers(users_list.users)
      // setDataTotal(response.data);
      setDataLeads(response3.data.by_process);

      setDataSource(source_response.data.by_source);
      setDataActivity(response4.data.by_activity);
      setDataProgram([]);
      setDataStatus(status_response.data.by_status);

      setDataUsers(users_list.users)
      setDataTotal(null);
      // setDataLeads([]);
      setDataProgram([]);


    } catch (err) {
      // const errorMessage = err instanceof Error ? err.message : 'Error desconocido';
      // setError(errorMessage);
      console.error(err);
      
      setDataTotal(null);
      setDataLeads([]);
      setDataSource([]);
      setDataActivity([]);
      setDataProgram([]);
      setDataStatus([]);
      setDataUsers([])
    } finally {
      setLoading(false);
    }
  }, [params.user_id, params.start_date, params.end_date]);

  // Cargar datos automáticamente cuando cambien los parámetros
  useEffect(() => {
    if (params.autoFetch !== false) {
      fetchData();
    }
  }, [fetchData, params.autoFetch]);

  return {
    dataTotal,
    dataLeads,
    dataSource,
    dataActivity,
    dataProgram,
    dataStatus,
    dataUsers,
    loading,
    error,
    fetchData,
    refetch: fetchData, // Alias para refrescar manualmente
  };
};